import { BondFilterCriteria } from "./BondFilterCriteria";
import { BondFilterDataConstraints } from "./BondFilterDataConstraints";

export function createDefaultValuesFromConstraints(
  bondFilerConstraints: BondFilterDataConstraints,
): BondFilterCriteria {
  return {
    amountOutstanding: bondFilerConstraints.amountOutstandingMin,
    esgScore: bondFilerConstraints.esgScoreMax,
    gSpreadAsk: bondFilerConstraints.gSpreadAskMin,
    selectedIndustries: [],
    maturityYearsLowerBound: bondFilerConstraints.maturityMin,
    maturityYearsHigherBound: bondFilerConstraints.maturityMax,
    purchasePriceLowerBound: bondFilerConstraints.purchasePriceMin,
    purchasePriceHigherBound: bondFilerConstraints.purchasePriceMax,
    moodysRatingIndex: bondFilerConstraints.ratingIndexMin,
    sAndPratingIndex: bondFilerConstraints.ratingIndexMin,
    moodysOrSandPRatingIndex: bondFilerConstraints.ratingIndexMin,
    yieldPercentage: bondFilerConstraints.yieldPercentageMin,
    separateRatings: false,
    bothOrOne: "both",
    favorite: false,
    searchString: "",
    minimumAmount1000: false,
  };
}
